import { useEffect } from 'react';
import { AnimatePresence, m } from 'framer-motion';
import { dismissAchievementToast, useAchievementToast } from '../achievements';
import { useCelebrating } from '../levelUp';

// Mounted once at the root: a small "🏅 Achievement unlocked" banner that
// slides in at the top, stays a few seconds, and never blocks play. Waits
// while a level-up is being celebrated.
export function AchievementToastHost() {
  const current = useAchievementToast();
  const celebrating = useCelebrating();
  const shown = current && !celebrating ? current : null;

  useEffect(() => {
    if (!shown) return;
    const t = setTimeout(dismissAchievementToast, 3200);
    return () => clearTimeout(t);
  }, [shown]);

  return (
    <AnimatePresence>
      {shown && (
        <m.button
          key={shown.id}
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 24 }}
          aria-live="polite"
          style={{
            position: 'fixed', top: 'calc(0.75rem + env(safe-area-inset-top, 0px))', left: '50%', x: '-50%', zIndex: 1200,
            display: 'flex', alignItems: 'center', gap: '0.7rem', padding: '0.65rem 1rem', width: 'min(92vw, 380px)',
            borderRadius: '16px', background: '#1B1830', border: '2px solid #FFC93C', boxShadow: '0 8px 30px rgba(0,0,0,0.5)',
            // Taps pass straight through: it hides itself after a moment, and it must never eat an answer tap.
            color: '#fff', pointerEvents: 'none', textAlign: 'left',
          }}
        >
          <span style={{ fontSize: '2rem', lineHeight: 1 }}>{shown.icon}</span>
          <span style={{ minWidth: 0 }}>
            <span style={{ display: 'block', color: '#FFC93C', fontSize: '0.7rem', fontWeight: 800, letterSpacing: '0.1em' }}>{shown.kicker ?? '🏅 ACHIEVEMENT UNLOCKED'}</span>
            <span style={{ display: 'block', fontWeight: 800 }}>{shown.title}</span>
            <span style={{ display: 'block', color: '#aaa', fontSize: '0.8rem' }}>{shown.desc}</span>
          </span>
        </m.button>
      )}
    </AnimatePresence>
  );
}
